import { ICONS } from '@/assets/icons';

/**
 * The finite set of meta-item types a `PageHeader.MetaItem` can represent.
 *
 * Each type maps to a stable icon via `META_ITEM_ICONS`. Extending this union
 * is a deliberate design-system act — see ADR-005.
 */
export type PageHeaderMetaItemType =
  | 'address'
  | 'portfolio'
  | 'country'
  | 'classOfUseResidential'
  | 'classOfUseCommercial'
  | 'typeOfUse'
  | 'constructionYear'
  | 'floorArea'
  | 'totalFloorArea'
  | 'buildingValue'
  | 'buildingCount'
  | 'createdBy'
  | 'costVersion'
  | 'scenario'
  | 'economicUnit'
  | 'renovationType'
  | 'responsibleUser'
  | 'customProperty'
  | 'completeness'
  | 'entriesToReview';

export const META_ITEM_ICONS: Record<PageHeaderMetaItemType, ICONS> = {
  address: ICONS.RESIDENTIAL_BUILDING,
  portfolio: ICONS.PORTFOLIO,
  country: ICONS.COUNTRY,
  classOfUseResidential: ICONS.RESIDENTIAL_BUILDING,
  classOfUseCommercial: ICONS.COMMERCIAL_BUILDING,
  typeOfUse: ICONS.COMMERCIAL_BUILDING,
  constructionYear: ICONS.CONSTRUCTION_YEAR,
  floorArea: ICONS.AREA,
  totalFloorArea: ICONS.AREA2,
  buildingValue: ICONS.EURO,
  buildingCount: ICONS.BUILDING,
  createdBy: ICONS.ACCOUNT_OUTLINE,
  costVersion: ICONS.COST_VERSION,
  renovationType: ICONS.CONSTRUCTION_YEAR,
  scenario: ICONS.GAUGE,
  economicUnit: ICONS.DOMAIN,
  responsibleUser: ICONS.ACCOUNT_OUTLINE,
  customProperty: ICONS.LABEL_OUTLINE,
  completeness: ICONS.BAROMETER,
  entriesToReview: ICONS.INFO_CONTAINED,
};
